import React from "react";
import { Abm } from ".";

export const FormTemplate = (props) =>{
  const FormTemplates = Abm("templates");
  return <FormTemplates {...props}/>
} 